import { ActionButton } from "../components/actionButton";
import { ChatBot } from "../components/chatBot";
// import { useChatBotConfigContext } from "../providers/chatBotConfigContext";

export const ChatBotView = () => {
  return (
    <>
      <ChatBot />
    </>
  );
};
